/**
 * Hulpen voor de kaart (sessie 73 blok 2): smal scherm (iPhone) en een
 * afbeelding achter het token als object-URL.
 */
import { useEffect, useState } from "react";

import { v6Api } from "../../api";

export const SMAL = "(max-width: 900px)";

function isSmal(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(SMAL).matches
    : false;
}

/** Waar op een smal scherm (iPhone): vlakken schuiven dan over de kaart. */
export function useSmal(): boolean {
  const [smal, setSmal] = useState(isSmal);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const lijst = window.matchMedia(SMAL);
    const bij = () => setSmal(lijst.matches);
    lijst.addEventListener?.("change", bij);
    return () => lijst.removeEventListener?.("change", bij);
  }, []);
  return smal;
}

/**
 * Een beveiligde afbeelding (Bearer-token) als object-URL; opgeruimd bij
 * een andere url of bij het weghalen. `null` zolang hij laadt of mislukt.
 */
export function useAfbeelding(url: string | null): { src: string | null; mislukt: boolean } {
  const [stand, setStand] = useState<{ url: string | null; src: string | null; mislukt: boolean }>({
    url: null,
    src: null,
    mislukt: false,
  });
  useEffect(() => {
    if (!url) return;
    let actief = true;
    let gemaakt: string | null = null;
    v6Api
      .laadAfbeelding(url)
      .then((blob) => {
        if (!actief) return;
        gemaakt = URL.createObjectURL(blob);
        setStand({ url, src: gemaakt, mislukt: false });
      })
      .catch(() => {
        if (actief) setStand({ url, src: null, mislukt: true });
      });
    return () => {
      actief = false;
      if (gemaakt) URL.revokeObjectURL(gemaakt);
    };
  }, [url]);
  if (!url || stand.url !== url) return { src: null, mislukt: false };
  return { src: stand.src, mislukt: stand.mislukt };
}
